import React, { useEffect } from 'react';
import { EditView } from 'components/Crud';
import { engineerDomain } from 'models';
import { useDispatch } from 'react-redux';
import { DomainItem } from 'models/Domain';
import { mapResponseDataToField } from 'components/Forms/utils/dataMap';
import Engineer from 'models/Engineers';
import { mergeErrors } from 'utils';
import {
  useSkillsState,
  usePatchesState,
  useShiftPatternsState,
  useTeamsState
} from 'store/selectors';
import { fetchAllSkills } from 'store/slices/skills';
import { fetchAllPatches } from 'store/slices/patches';
import { fetchAllShiftPatterns } from 'store/slices/shiftPatterns';
import { fetchAllTeams } from 'store/slices/teams';
import { engineerFormFields, validationSchema } from './formConfig';
import { isAnyLoading, processFormFields } from './utils';

function EditEngineerView() {
  const dispatch = useDispatch();

  const skillsSelector = useSkillsState();
  const patchesSelector = usePatchesState();
  const shiftPatternsSelector = useShiftPatternsState();
  const teamsSelector = useTeamsState();

  const isLoading = isAnyLoading(
    skillsSelector,
    patchesSelector,
    shiftPatternsSelector,
    teamsSelector
  );

  const error = mergeErrors([
    skillsSelector.error,
    patchesSelector.error,
    shiftPatternsSelector.error,
    teamsSelector.error
  ]);

  const processEngineerData = (item: DomainItem) => {
    return mapResponseDataToField(
      {
        team: (engineer: Engineer) => (engineer.team ? engineer.team.id : ''),
        defaultPatch: (engineer: Engineer) => engineer.defaultPatch.id,
        defaultShiftPattern: (engineer: Engineer) =>
          engineer.defaultShiftPattern.id,
        skills: (engineer: Engineer) => engineer.skills,
        maxTravelTime: (engineer: Engineer) => engineer.maxTravelTime
      },
      item as Engineer
    );
  };

  useEffect(() => {
    dispatch(fetchAllSkills());
    dispatch(fetchAllPatches());
    dispatch(fetchAllShiftPatterns());
    dispatch(fetchAllTeams());
  }, []);

  return (
    <EditView
      domain={engineerDomain}
      fields={engineerFormFields(
        'edit',
        skillsSelector.items,
        patchesSelector.items,
        shiftPatternsSelector.items,
        teamsSelector.items
      )}
      validationSchema={validationSchema()}
      presubmitCallback={processFormFields}
      processDomainData={processEngineerData}
      loading={isLoading}
      error={error}
    />
  );
}

export default EditEngineerView;
